import options from './user-popover.component';

export default {
    selector: 'dtUserPopover',
    options
};
